import { StaticTextRow, TextFieldRow } from 'components';

const ChildEmail = ({
	status,
	editable,
	reinvite,
	onResend,
	email,
	...rest
}) => {
	return status === 'active' && !editable ? (
		<StaticTextRow {...{ ...rest, label: rest.label + ' (verified)' }} />
	) : (
		<TextFieldRow {...rest} />
	);
};

export default ChildEmail;
